<script setup lang="ts">
import { type ModalInstance } from '../types/modalInstance';
import { useModalStore } from '../store';
import { useModalInstance } from '../useModal';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    name?: string;
    transition: string;
  }>(),
  {
    name: 'default',
    transition: 'popup',
  },
);

const modals = useModalStore();
const queue = computed(() => modals.open[props.name]);

const onInput = (instance: ModalInstance<any>, value: any) => {
  const modal = useModalInstance(instance);

  modal.resolve(value);
  modal.close();
};
</script>

<template>
  <TransitionGroup tag="div" :name="transition" class="dropdown-click-outside-ignored">
    <Component
      :is="modal.component"
      v-for="modal in queue"
      :key="modal.id"
      v-bind="modal.props"
      @input="onInput(modal, $event)"
    />
  </TransitionGroup>
</template>

<style>
.popup-enter-active,
.popup-leave-active {
  transition: all 0.1s ease;
}
.popup-enter-from,
.popup-leave-to {
  opacity: 0;
  transform: translateY(5px);
}

.nudge-enter-active {
  animation: nudge 0.25s;
}
.nudge-leave-active {
  animation: nudge 0.15s reverse;
}

@keyframes nudge {
  0% {
    transform: translateY(-30px);
    opacity: 0;
  }
  75% {
    transform: translateY(2px);
    opacity: 1;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
</style>
